/**
 * Hämtar bilder till Excel-exporten och skalar ner dem i webbläsaren, så att
 * filen hålls liten. En källa är en Storage-sökväg ('kunder/{id}/logo.jpg')
 * eller en webbadress. Bilder som inte går att hämta hoppas över: cellen
 * blir tom.
 */
import { ref as storageRef, getBlob } from 'firebase/storage';
import { storage } from '../firebase/config';
import { arExternUrl } from '../modules/crm/bilder';
import { skalaBild } from '../modules/crm/bildkopia';

/** Största sida på en inbäddad bild, i px. */
export const EXPORT_BILD_PX = 64;

async function hamtaBlob(kalla) {
  if (arExternUrl(kalla)) {
    const res = await fetch(kalla, { mode: 'cors' });
    if (!res.ok) throw new Error(`HTTP ${res.status}`);
    return res.blob();
  }
  return getBlob(storageRef(storage, kalla));
}

function blobTillBase64(blob) {
  return new Promise((resolve, reject) => {
    const r = new FileReader();
    r.onload = () => resolve(String(r.result).split(',')[1]);
    r.onerror = () => reject(r.error);
    r.readAsDataURL(blob);
  });
}

/**
 * @param {string[]} kallor  Storage-sökvägar eller URL:er (dubbletter och tomma ignoreras)
 * @returns {Promise<Map<string, {base64, extension}>>}  per källa, i ExcelJS addImage-format
 */
export async function hamtaBilder(kallor, { px = EXPORT_BILD_PX, parallellt = 6, onProgress } = {}) {
  const unika = [...new Set(kallor.filter(Boolean))];
  const resultat = new Map();
  let i = 0;
  let klara = 0;
  const arbetare = async () => {
    while (i < unika.length) {
      const kalla = unika[i++];
      try {
        const jpeg = await skalaBild(await hamtaBlob(kalla), px);
        resultat.set(kalla, { base64: await blobTillBase64(jpeg), extension: 'jpeg' });
      } catch (e) {
        console.warn('Bild hoppas över i exporten', kalla, e);
      }
      klara += 1;
      onProgress?.(klara, unika.length);
    }
  };
  await Promise.all(Array.from({ length: Math.min(parallellt, unika.length) }, arbetare));
  return resultat;
}
